<template>
  <div :class="['navigationBar', color ? `${color}Buttons` : '', fixed ? 'fixed' : '']">
    <CloseButton :theme="theme"></CloseButton>
    <ShareButton :theme="theme"></ShareButton>
  </div>
</template>

<script>

  import CloseButton from "@/components/buttons/navigation/CloseButton";
  import ShareButton from "@/components/buttons/navigation/ShareButton";

  export default {
    name: 'NavigationBar',
    components: {ShareButton, CloseButton},
    props: ['fixed', 'color', 'theme'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
      console.log(`Passed ${this.color} to navbar`)
    }
  }
</script>

<style lang="scss">

  .navigationBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: calc(0.875rem + env(safe-area-inset-left));
    padding-right: calc(0.875rem + env(safe-area-inset-right));
    padding-top: calc(3.37500rem + env(safe-area-inset-top));
    padding-bottom: calc(3.37500rem + env(safe-area-inset-bottom));

    &.fixed {
      position: fixed;
      width: 100%;
      z-index: 100;
    }

    &.solidButtons {
      .navigationButtonWrapper {
        background-color: rgba(255, 255, 255, 1) !important;
        border: 1px solid #c9c8c8;
      }
    }
  }

</style>
